/** Direct saved studies reuse the existing confirmation screen. Retired identities never load old storage. */
import { DirectStudyRunRoute } from './direct-studies/DirectStudyRunRoute'
import { RetiredStudyPage } from './RetiredStudyPage'
import type { ShopifyAppViewState } from '../resultsNavigation'
import type { shopifyApiFetch } from '../shopifyApiFetch'

export function StudyRunRoute({
  appView,
  shopify,
  onBackToStudies,
}: {
  appView: Extract<ShopifyAppViewState, { view: 'study-run' }>
  shopify: Parameters<typeof shopifyApiFetch>[0]
  onBackToStudies: () => void
}) {
  if (appView.studyId)
    return <DirectStudyRunRoute shopify={shopify} studyId={appView.studyId} onBack={onBackToStudies} />
  return <RetiredStudyPage onBack={onBackToStudies} />
}
